export default __webpack_public_path__ + "static/media/icn-filter-white.f67995ff.svg";